module.exports = __webpack_public_path__ + "media/images/empty-trash-bottom-5c1fe4bb.svg";